<div class="shop-items-container">
  <div class="shop-items-filter-container">
    <form [formGroup]="shopItemsForm" class="verifications-search-form">

      <mat-form-field class="mat-form-field form-field name" appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="query" placeholder="name">
      </mat-form-field>

      <mat-form-field class="mat-form-field form-field " appearance="outline">
        <mat-label>Min price</mat-label>
        <input matInput formControlName="minPrice" placeholder="min price в центах" type="number" class="no-arrows">
      </mat-form-field>

      <mat-form-field class="mat-form-field form-field " appearance="outline">
        <mat-label>Max price</mat-label>
        <input matInput formControlName="maxPrice" placeholder="max price в центах" type="number" class="no-arrows">
      </mat-form-field>


      <button mat-stroked-button color="primary" (click)="search()" class="search-btn">Search</button>

    </form>
  </div>

  <div class="shop-items-table-container">
    <div class="table-wrapper table-density">
      <div class="table-loading" *ngIf="shopItemsSource.isLoading$ | async">
        <mat-spinner diameter="20" style="margin: 0 auto"></mat-spinner>
      </div>
      <table mat-table [dataSource]="shopItemsSource" class="table shop-items-table" matSort>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="item">
          <th mat-header-cell *matHeaderCellDef>Item</th>
          <td mat-cell *matCellDef="let element">{{ element.baseItem.name }}</td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef>Price</th>
          <td mat-cell *matCellDef="let element">{{ element.price / 100 | currency: 'USD' }}</td>
        </ng-container>

        <ng-container matColumnDef="steamPrice">
          <th mat-header-cell *matHeaderCellDef>Steam</th>
          <td mat-cell *matCellDef="let element">{{ element.steamPrice / 100 | currency: 'USD' }}</td>
        </ng-container>

        <ng-container matColumnDef="available">
          <th mat-header-cell *matHeaderCellDef>Available</th>
          <td mat-cell *matCellDef="let element">{{ element.available ? 'Да' : 'Нет' }}</td>
        </ng-container>


        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element">
            <div class="btn-group controls">
              <button class="btn btn-sm btn-hold"
                      (click)="selectItem(element)">Select
              </button>
            </div>
          </td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="shopItemColumns.length">
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="shopItemColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: shopItemColumns;"></tr>
      </table>
    </div>
  </div>

  <mat-paginator [length]="shopItemsSource.totalCount" class="paginator"
                 [pageSizeOptions]="[10, 50, 250, 500]">
  </mat-paginator>
</div>



